import Nuts from "../../data/Nutrients";
import RecipeCache from "../../data/RecipeCache";
import { IFoodAmount } from "../../shared/Recipes";
import FactRow from "./FactRow";

export default function FactsheetTotal(props:{foods:IFoodAmount[], portion?:number}) {
    const facts = RecipeCache.getFacts(new Map<number,number>(), props.foods, props.portion || 1)
    const foods = Array.from(facts.entries()).map(([fid,amount]) => {
        const nut = Nuts.i.fromCache(fid.toString())
        return nut ? <FactRow key={fid} amount={amount} nut={nut}/> : null
    })
    
    return <div className="factsheet">{foods}</div>
}